import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react';
import H6 from '../../components/Titles/h6';
import FullWidthImage from '../../components/Images/image-full-width';
import ButtonSecondary from '../../components/Buttons/button-secondary';

export default function CardProduct({ product }) {
    const [minimalPrice, setMinimalPrice] = useState(0);
    const [displayPriceFrom, setDisplayPriceFrom] = useState(false);

    const { t, i18n } = useTranslation();

    const buildImageUrl = (src) => {
        if (!src) return '';
        if (src.startsWith('http://') || src.startsWith('https://')) return src;
        return `https://api.lartbanne.com/uploads/artbanne/${src}`;
    };

    // Helper function to get the name safely
    const getProductName = () => {
        if (!product || !product.name) return '';

        return (
            product.name[i18n.language] ||
            product.name.fr ||
            product.name.en ||
            Object.values(product.name)[0] ||
            ''
        );
    };

    const productName = getProductName();

    useEffect(() => {
        if (!product || !product.modelProduct || !product.modelProduct.length) return;

        let tmpMinimalPrice = null;
        let hasDifferentPrices = false;

        for (const model of product.modelProduct) {
            const price = Number(model.priceTTC) || 0;

            if (tmpMinimalPrice === null || price < tmpMinimalPrice) {
                tmpMinimalPrice = price;
            }

            if (tmpMinimalPrice !== null && price !== tmpMinimalPrice) {
                hasDifferentPrices = true;
            }
        }

        setMinimalPrice(tmpMinimalPrice ?? 0);
        setDisplayPriceFrom(hasDifferentPrices);
    }, [product]);

    return (
        <div className="bg-white shadow text-center flex flex-col justify-between gap-3 px-2 py-4 cursor-pointer h-full">
            <FullWidthImage
                url={buildImageUrl(product.imageSrc)}
                alt={t('shop.alt') + ' ' + productName}
            />

            <H6 title={productName} />

            <div>
                {displayPriceFrom && <span>{t('shop.form')}</span>}
                <H6
                    title={`${minimalPrice.toFixed(2)} EUR`}
                    fontWeight='bold'
                />
            </div>

            <div className='w-fit text-center my-0 mx-auto'>
                <ButtonSecondary text={t('inputs.addToCart')} />
            </div>
        </div>
    );
}